import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect, useState } from "react";
import { initAuth } from "@/store/authStore";
import { useAuth } from "@/hooks/useAuth";
import { ErrorBoundary } from "@/components/base/ErrorBoundary";
import { ToastContainer } from "@/components/base/Toast";

function SessionBoot({ children }: { children: React.ReactNode }) {
  const { isInitializing } = useAuth();
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (!started) {
      setStarted(true);
      initAuth();
    }
  }, [started]);

  // Attempting a silent refresh from the stored refresh token — avoids a login-page
  // flash for users who are actually still authenticated after a page reload.
  if (isInitializing) {
    return (
      <div className="min-h-[100dvh] flex items-center justify-center bg-white">
        <span className="w-10 h-10 border-4 border-agrida-200 border-t-agrida-600 rounded-full animate-spin" />
      </div>
    );
  }

  return <>{children}</>;
}

function App() {
  return (
    <ErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <SessionBoot>
            <AppRoutes />
          </SessionBoot>
          <ToastContainer />
        </BrowserRouter>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
